/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/additionalPoint/edit/additional-point-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../../public/upgrade/feature/pointOfSale/point-of-sale.service';
import * as import6 from '../../../../../../public/upgrade/feature/additionalPoint/additional-point.service';
import * as import7 from '../../../../../../public/upgrade/feature/additionalPoint/edit/additional-point-validator.service';
import * as import8 from '../../../../../../public/upgrade/feature/pointOfSale/edit/point-of-sale-validator.service';
import * as import9 from '../../../../../../public/upgrade/core/geo-code.service';
import * as import10 from '@angular/core/src/linker/view_type';
import * as import11 from '@angular/core/src/change_detection/constants';
import * as import12 from '@angular/core/src/linker/component_factory';
import * as import13 from '@angular/http/src/http';
import * as import14 from '../../../../../../public/upgrade/core/alfred.service';
import * as import15 from '@angular/core/src/zone/ng_zone';
import * as import16 from '@angular/router/src/router_state';
import * as import17 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import18 from '@angular/router/src/router';
import * as import19 from '../../../../../../public/upgrade/root/modal/modal.service';
import * as import20 from '../../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import21 from '@angular/forms/src/form_builder';
import * as import22 from '../../../../../../public/upgrade/root/sidebar/sidebar.service';
import * as import23 from '../../../../../../public/upgrade/core/session.service';
import * as import24 from '../../../../../../public/upgrade/core/logger.service';
import * as import25 from '@ngx-translate/core/src/translate.service';
import * as import26 from '../../../../../../public/upgrade/feature/additionalPoint/selector/selector.component';
import * as import27 from '../selector/selector.component.ngfactory';
import * as import28 from '@ngx-translate/core/src/translate.pipe';
import * as import29 from '@angular/core/src/linker/view_container';
import * as import30 from '@angular/core/src/change_detection/change_detection_util';
import * as import31 from '../../../../../../public/upgrade/feature/pointOfSale/edit/office-location/office-location.component';
import * as import32 from '../../pointOfSale/edit/office-location/office-location.component.ngfactory';
import * as import33 from '../../../../../../public/upgrade/core/geo_a2.service';
import * as import34 from '../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/delivery-instructions.component';
import * as import35 from '../../pointOfSale/delivery-instructions/delivery-instructions.component.ngfactory';
import * as import36 from '../../../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import37 from '../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import38 from '../../../../../../public/upgrade/shared/input-container/input-container.component';
import * as import39 from '../../../shared/input-container/input-container.component.ngfactory';
import * as import40 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import41 from '@angular/core/src/linker/template_ref';
import * as import42 from '@angular/common/src/directives/ng_if';
import * as import43 from '@angular/forms/src/directives/ng_form';
import * as import44 from '@angular/forms/src/directives/control_container';
import * as import45 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_AdditionalPointEditComponent {
  /*private*/ _eventHandler:Function;
  context:import0.AdditionalPointEditComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any,p11:any,p12:any,p13:any,p14:any) {
    this._changed = false;
    this.context = new import0.AdditionalPointEditComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_AdditionalPointEditComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_AdditionalPointEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.AdditionalPointEditComponent>;
  _PointOfSaleServiceA2_0_3:import5.PointOfSaleServiceA2;
  _AdditionalPointService_0_4:import6.AdditionalPointService;
  _AdditionalPointValidatorService_0_5:import7.AdditionalPointValidatorService;
  _PointOfSaleValidatorService_0_6:import8.PointOfSaleValidatorService;
  _AdditionalPointEditComponent_0_7:Wrapper_AdditionalPointEditComponent;
  __GeoCodeService_0_8:import9.GeoCodeService;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AdditionalPointEditComponent_Host0,renderType_AdditionalPointEditComponent_Host,import10.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import11.ChangeDetectorStatus.CheckAlways);
  }
  get _GeoCodeService_0_8():import9.GeoCodeService {
    if ((this.__GeoCodeService_0_8 == null)) { (this.__GeoCodeService_0_8 = new import9.GeoCodeService()); }
    return this.__GeoCodeService_0_8;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'additional-point-edit',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_AdditionalPointEditComponent0(this.viewUtils,this,0,this._el_0);
    this._PointOfSaleServiceA2_0_3 = new import5.PointOfSaleServiceA2(this.injectorGet(import13.Http,this.parentIndex),this.injectorGet(import14.AlfredA2Service,this.parentIndex));
    this._AdditionalPointService_0_4 = new import6.AdditionalPointService(this.injectorGet(import13.Http,this.parentIndex),this._PointOfSaleServiceA2_0_3);
    this._AdditionalPointValidatorService_0_5 = new import7.AdditionalPointValidatorService();
    this._PointOfSaleValidatorService_0_6 = new import8.PointOfSaleValidatorService();
    this._AdditionalPointEditComponent_0_7 = new Wrapper_AdditionalPointEditComponent(this._AdditionalPointService_0_4,this.injectorGet(import15.NgZone,this.parentIndex),this.injectorGet(import16.ActivatedRoute,this.parentIndex),this.injectorGet(import17.NotificationService,this.parentIndex),this.injectorGet(import18.Router,this.parentIndex),this.injectorGet(import19.ModalService,this.parentIndex),this.injectorGet(import20.LoadingWheelService,this.parentIndex),this.injectorGet(import21.FormBuilder,this.parentIndex),this.injectorGet(import22.SidebarService,this.parentIndex),this._AdditionalPointValidatorService_0_5,this.injectorGet(import23.SessionService,this.parentIndex),this._PointOfSaleValidatorService_0_6,this.injectorGet(import24.LoggerService,this.parentIndex),this.injectorGet(import25.TranslateService,this.parentIndex),this._PointOfSaleServiceA2_0_3);
    this.compView_0.create(this._AdditionalPointEditComponent_0_7.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import12.ComponentRef_<any>(0,this,this._el_0,this._AdditionalPointEditComponent_0_7.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.PointOfSaleServiceA2) && (0 === requestNodeIndex))) { return this._PointOfSaleServiceA2_0_3; }
    if (((token === import6.AdditionalPointService) && (0 === requestNodeIndex))) { return this._AdditionalPointService_0_4; }
    if (((token === import7.AdditionalPointValidatorService) && (0 === requestNodeIndex))) { return this._AdditionalPointValidatorService_0_5; }
    if (((token === import8.PointOfSaleValidatorService) && (0 === requestNodeIndex))) { return this._PointOfSaleValidatorService_0_6; }
    if (((token === import0.AdditionalPointEditComponent) && (0 === requestNodeIndex))) { return this._AdditionalPointEditComponent_0_7.context; }
    if (((token === import9.GeoCodeService) && (0 === requestNodeIndex))) { return this._GeoCodeService_0_8; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AdditionalPointEditComponent_0_7.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const AdditionalPointEditComponentNgFactory:import12.ComponentFactory<import0.AdditionalPointEditComponent> = new import12.ComponentFactory<import0.AdditionalPointEditComponent>('additional-point-edit',View_AdditionalPointEditComponent_Host0,import0.AdditionalPointEditComponent);
const styles_AdditionalPointEditComponent:any[] = ([] as any[]);
class View_AdditionalPointEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  compView_19:import1.AppView<import26.SelectorComponent>;
  _SelectorComponent_19_3:import27.Wrapper_SelectorComponent;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  /*private*/ _expr_27:any;
  _pipe_translate_0:import28.TranslatePipe;
  _pipe_translate_1:import28.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import29.ViewContainer) {
    super(View_AdditionalPointEditComponent1,renderType_AdditionalPointEditComponent,import10.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import11.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_27 = import30.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'span',new import3.InlineArray2(2,'class','red'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'*',(null as any));
    this._text_12 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._text_14 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-pt-sm'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                                ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'selector-item',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_19 = new import27.View_SelectorComponent0(this.viewUtils,this,19,this._el_19);
    this._SelectorComponent_19_3 = new import27.Wrapper_SelectorComponent();
    this._text_20 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this.compView_19.create(this._SelectorComponent_19_3.context);
    this._text_21 = this.renderer.createText(this._el_17,'\n                            ',(null as any));
    this._text_22 = this.renderer.createText(this._el_15,'\n                        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._pipe_translate_0 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_19,new import3.InlineArray8(6,'dtoChange',(null as any),'modelChange',(null as any),'onChange',(null as any)),this.eventHandler(this.handleEvent_19));
    this._SelectorComponent_19_3.subscribe(this,this.eventHandler(this.handleEvent_19),true,true);
    this._pipe_translate_1 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.SelectorComponent) && ((19 <= requestNodeIndex) && (requestNodeIndex <= 20)))) { return this._SelectorComponent_19_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import30.ValueUnwrapper();
    const currVal_19_0_0:any = this.parentView.context.dto;
    this._SelectorComponent_19_3.check_dto(currVal_19_0_0,throwOnChange,false);
    const currVal_19_0_1:boolean = !!this.parentView.context.errors['addpuPosAssociated'];
    this._SelectorComponent_19_3.check_invalid(currVal_19_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_19_0_2:any = valUnwrapper.unwrap(this._pipe_translate_1.transform(this.parentView.context.errorMessages['addpuPosAssociated']));
    this._SelectorComponent_19_3.check_invalidText(currVal_19_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_19_0_3:any = this.parentView.context.data.pointsOfSale;
    this._SelectorComponent_19_3.check_list(currVal_19_0_3,throwOnChange,false);
    const currVal_19_0_4:any = this.parentView.context.dto.pointOfSaleOid;
    this._SelectorComponent_19_3.check_model(currVal_19_0_4,throwOnChange,false);
    this._SelectorComponent_19_3.ngDoCheck(this,this._el_19,throwOnChange);
    valUnwrapper.reset();
    const currVal_27:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.POS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_27,currVal_27))) {
      this.renderer.setText(this._text_9,currVal_27);
      this._expr_27 = currVal_27;
    }
    this.compView_19.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_19.destroy();
    this._SelectorComponent_19_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_19(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'modelChange')) {
      const pd_sub_1:any = ((<any>(this.parentView.context.dto.pointOfSaleOid = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    if ((eventName == 'onChange')) {
      const pd_sub_2:any = ((<any>this.parentView.context.callingData($event,true)) !== false);
      result = (pd_sub_2 && result);
    }
    return result;
  }
}
class View_AdditionalPointEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import31.OfficeLocationComponent>;
  _GeoCodeService_2_3:import9.GeoCodeService;
  _OfficeLocationComponent_2_4:import32.Wrapper_OfficeLocationComponent;
  __PointOfSaleServiceA2_2_5:import5.PointOfSaleServiceA2;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import29.ViewContainer) {
    super(View_AdditionalPointEditComponent2,renderType_AdditionalPointEditComponent,import10.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import11.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  get _PointOfSaleServiceA2_2_5():import5.PointOfSaleServiceA2 {
    if ((this.__PointOfSaleServiceA2_2_5 == null)) { (this.__PointOfSaleServiceA2_2_5 = new import5.PointOfSaleServiceA2(this.parentView.parentView.injectorGet(import13.Http,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import14.AlfredA2Service,this.parentView.parentIndex))); }
    return this.__PointOfSaleServiceA2_2_5;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'office-location',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import32.View_OfficeLocationComponent0(this.viewUtils,this,2,this._el_2);
    this._GeoCodeService_2_3 = new import9.GeoCodeService();
    this._OfficeLocationComponent_2_4 = new import32.Wrapper_OfficeLocationComponent(this.parentView.parentView.injectorGet(import15.NgZone,this.parentView.parentIndex),this._GeoCodeService_2_3,this.parentView.parentView.injectorGet(import33.GeoServiceA2,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import24.LoggerService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import25.TranslateService,this.parentView.parentIndex),this.compView_2.ref);
    this._text_3 = this.renderer.createText((null as any),'\n                    ',(null as any));
    this.compView_2.create(this._OfficeLocationComponent_2_4.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'dtoChange',(null as any),'onSelect',(null as any)),this.eventHandler(this.handleEvent_2));
    this._OfficeLocationComponent_2_4.subscribe(this,this.eventHandler(this.handleEvent_2),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import9.GeoCodeService) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._GeoCodeService_2_3; }
    if (((token === import31.OfficeLocationComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._OfficeLocationComponent_2_4.context; }
    if (((token === import5.PointOfSaleServiceA2) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._PointOfSaleServiceA2_2_5; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.subject;
    this._OfficeLocationComponent_2_4.check_subject(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.parentView.context.dto;
    this._OfficeLocationComponent_2_4.check_dto(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.isEditing;
    this._OfficeLocationComponent_2_4.check_isEditing(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this.parentView.context.errors;
    this._OfficeLocationComponent_2_4.check_errors(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parentView.context.errorMessages;
    this._OfficeLocationComponent_2_4.check_errorMessages(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parentView.context.posSelected;
    this._OfficeLocationComponent_2_4.check_posSelected(currVal_2_0_5,throwOnChange,false);
    const currVal_2_0_6:any = this.parentView.context.isValid;
    this._OfficeLocationComponent_2_4.check_isValid(currVal_2_0_6,throwOnChange,false);
    const currVal_2_0_7:any = this.parentView.context.errorKey;
    this._OfficeLocationComponent_2_4.check_errorKey(currVal_2_0_7,throwOnChange,false);
    this._OfficeLocationComponent_2_4.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._OfficeLocationComponent_2_4.context.ngAfterViewInit(); }
      this._OfficeLocationComponent_2_4.context.ngAfterViewChecked();
    }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._OfficeLocationComponent_2_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'onSelect')) {
      const pd_sub_1:any = ((<any>this.parentView.context.callingData($event,false)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_AdditionalPointEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import34.DeliveryInstructionsComponent>;
  _DeliveryInstructionsComponent_2_3:import35.Wrapper_DeliveryInstructionsComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import29.ViewContainer) {
    super(View_AdditionalPointEditComponent3,renderType_AdditionalPointEditComponent,import10.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import11.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'delivery-instructions',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import35.View_DeliveryInstructionsComponent0(this.viewUtils,this,2,this._el_2);
    this._DeliveryInstructionsComponent_2_3 = new import35.Wrapper_DeliveryInstructionsComponent(this.parentView.parentView.injectorGet(import24.LoggerService,this.parentView.parentIndex));
    this._text_3 = this.renderer.createText((null as any),'\n                    ',(null as any));
    this.compView_2.create(this._DeliveryInstructionsComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import34.DeliveryInstructionsComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._DeliveryInstructionsComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.errors;
    this._DeliveryInstructionsComponent_2_3.check_errors(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.parentView.context.errorMessages;
    this._DeliveryInstructionsComponent_2_3.check_errorMessages(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.dto;
    this._DeliveryInstructionsComponent_2_3.check_dto(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this.parentView.context.countryId;
    this._DeliveryInstructionsComponent_2_3.check_countryId(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = true;
    this._DeliveryInstructionsComponent_2_3.check_hasOtherDeliveryMessage(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parentView.context.enabledCity;
    this._DeliveryInstructionsComponent_2_3.check_enabledCity(currVal_2_0_5,throwOnChange,false);
    const currVal_2_0_6:any = this.parentView.context.isPointOfSale;
    this._DeliveryInstructionsComponent_2_3.check_isPointOfSale(currVal_2_0_6,throwOnChange,false);
    const currVal_2_0_7:any = this.parentView.context.isValid;
    this._DeliveryInstructionsComponent_2_3.check_isValidLocation(currVal_2_0_7,throwOnChange,false);
    this._DeliveryInstructionsComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_AdditionalPointEditComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_AdditionalPointEditComponent,{});
export class View_AdditionalPointEditComponent0 extends import1.AppView<import0.AdditionalPointEditComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _NgForm_4_3:import36.Wrapper_NgForm;
  _ControlContainer_4_4:any;
  _NgControlStatusGroup_4_5:import37.Wrapper_NgControlStatusGroup;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _text_32:any;
  _el_33:any;
  _text_34:any;
  _el_35:any;
  _text_36:any;
  _el_37:any;
  _text_38:any;
  _el_39:any;
  compView_39:import1.AppView<import38.InputContainerComponent>;
  _InputContainerComponent_39_3:import39.Wrapper_InputContainerComponent;
  _text_40:any;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _el_46:any;
  _text_47:any;
  _el_48:any;
  compView_48:import1.AppView<import38.InputContainerComponent>;
  _InputContainerComponent_48_3:import39.Wrapper_InputContainerComponent;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  _anchor_57:any;
  /*private*/ _vc_57:import29.ViewContainer;
  _TemplateRef_57_5:any;
  _NgIf_57_6:import40.Wrapper_NgIf;
  _text_58:any;
  _anchor_59:any;
  /*private*/ _vc_59:import29.ViewContainer;
  _TemplateRef_59_5:any;
  _NgIf_59_6:import40.Wrapper_NgIf;
  _text_60:any;
  _anchor_61:any;
  /*private*/ _vc_61:import29.ViewContainer;
  _TemplateRef_61_5:any;
  _NgIf_61_6:import40.Wrapper_NgIf;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _el_65:any;
  _text_66:any;
  _el_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _text_74:any;
  _text_75:any;
  _text_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _text_80:any;
  _text_81:any;
  /*private*/ _expr_98:any;
  /*private*/ _expr_99:any;
  _pipe_translate_0:import28.TranslatePipe;
  /*private*/ _expr_101:any;
  _pipe_translate_1:import28.TranslatePipe;
  /*private*/ _expr_103:any;
  /*private*/ _expr_104:any;
  _pipe_translate_2:import28.TranslatePipe;
  _pipe_translate_3:import28.TranslatePipe;
  _pipe_translate_4:import28.TranslatePipe;
  _pipe_translate_5:import28.TranslatePipe;
  _pipe_translate_6:import28.TranslatePipe;
  /*private*/ _expr_110:any;
  /*private*/ _expr_111:any;
  _pipe_translate_7:import28.TranslatePipe;
  /*private*/ _expr_113:any;
  _pipe_translate_8:import28.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AdditionalPointEditComponent0,renderType_AdditionalPointEditComponent,import10.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import11.ChangeDetectorStatus.CheckAlways);
    this._expr_98 = import30.UNINITIALIZED;
    this._expr_99 = import30.UNINITIALIZED;
    this._expr_101 = import30.UNINITIALIZED;
    this._expr_103 = import30.UNINITIALIZED;
    this._expr_104 = import30.UNINITIALIZED;
    this._expr_110 = import30.UNINITIALIZED;
    this._expr_111 = import30.UNINITIALIZED;
    this._expr_113 = import30.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'form',new import3.InlineArray2(2,'name','addPosform'),(null as any));
    this._NgForm_4_3 = new import36.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_4_4 = this._NgForm_4_3.context;
    this._NgControlStatusGroup_4_5 = new import37.Wrapper_NgControlStatusGroup(this._ControlContainer_4_4);
    this._text_5 = this.renderer.createText(this._el_4,'\n\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-container eva3-restyle'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'h2',new import3.InlineArray2(2,'class','eva-3-h2'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_10,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_18 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_19 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n                    ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n                        ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n                            ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_24,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                                ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'',(null as any));
    this._text_30 = this.renderer.createText(this._el_26,'\n                            ',(null as any));
    this._text_31 = this.renderer.createText(this._el_24,'\n                        ',(null as any));
    this._text_32 = this.renderer.createText(this._el_22,'\n\n                        ',(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_34 = this.renderer.createText(this._el_33,'\n                            ',(null as any));
    this._el_35 = import3.createRenderElement(this.renderer,this._el_33,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-12'),(null as any));
    this._text_36 = this.renderer.createText(this._el_35,'\n\n                                ',(null as any));
    this._el_37 = import3.createRenderElement(this.renderer,this._el_35,'div',new import3.InlineArray2(2,'class','col -lg-8 -md-8 -sm-12'),(null as any));
    this._text_38 = this.renderer.createText(this._el_37,'\n                                    ',(null as any));
    this._el_39 = import3.createRenderElement(this.renderer,this._el_37,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_39 = new import39.View_InputContainerComponent0(this.viewUtils,this,39,this._el_39);
    this._InputContainerComponent_39_3 = new import39.Wrapper_InputContainerComponent();
    this._text_40 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_39.create(this._InputContainerComponent_39_3.context);
    this._text_41 = this.renderer.createText(this._el_37,'\n                                ',(null as any));
    this._text_42 = this.renderer.createText(this._el_35,'\n                            ',(null as any));
    this._text_43 = this.renderer.createText(this._el_33,'\n                            ',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_33,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-12'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'\n                                ',(null as any));
    this._el_46 = import3.createRenderElement(this.renderer,this._el_44,'div',new import3.InlineArray2(2,'class','col -lg-8 -md-8 -sm-12'),(null as any));
    this._text_47 = this.renderer.createText(this._el_46,'\n                                    ',(null as any));
    this._el_48 = import3.createRenderElement(this.renderer,this._el_46,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_48 = new import39.View_InputContainerComponent0(this.viewUtils,this,48,this._el_48);
    this._InputContainerComponent_48_3 = new import39.Wrapper_InputContainerComponent();
    this._text_49 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_48.create(this._InputContainerComponent_48_3.context);
    this._text_50 = this.renderer.createText(this._el_46,'\n                                ',(null as any));
    this._text_51 = this.renderer.createText(this._el_44,'\n                            ',(null as any));
    this._text_52 = this.renderer.createText(this._el_33,'\n                        ',(null as any));
    this._text_53 = this.renderer.createText(this._el_22,'\n                    ',(null as any));
    this._text_54 = this.renderer.createText(this._el_20,'\n                ',(null as any));
    this._text_55 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._text_56 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._anchor_57 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_57 = new import29.ViewContainer(57,6,this,this._anchor_57);
    this._TemplateRef_57_5 = new import41.TemplateRef_(this,57,this._anchor_57);
    this._NgIf_57_6 = new import40.Wrapper_NgIf(this._vc_57.vcRef,this._TemplateRef_57_5);
    this._text_58 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._anchor_59 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_59 = new import29.ViewContainer(59,6,this,this._anchor_59);
    this._TemplateRef_59_5 = new import41.TemplateRef_(this,59,this._anchor_59);
    this._NgIf_59_6 = new import40.Wrapper_NgIf(this._vc_59.vcRef,this._TemplateRef_59_5);
    this._text_60 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._anchor_61 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_61 = new import29.ViewContainer(61,6,this,this._anchor_61);
    this._TemplateRef_61_5 = new import41.TemplateRef_(this,61,this._anchor_61);
    this._NgIf_61_6 = new import40.Wrapper_NgIf(this._vc_61.vcRef,this._TemplateRef_61_5);
    this._text_62 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'\n                    ',(null as any));
    this._el_65 = import3.createRenderElement(this.renderer,this._el_63,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_66 = this.renderer.createText(this._el_65,'\n                        ',(null as any));
    this._el_67 = import3.createRenderElement(this.renderer,this._el_65,'div',new import3.InlineArray2(2,'class','col -md-12 -md-6'),(null as any));
    this._text_68 = this.renderer.createText(this._el_67,'\n                            ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_67,'dsp-button',new import3.InlineArray4(4,'size','md','variation','primary'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'',(null as any));
    this._text_71 = this.renderer.createText(this._el_67,'\n                            ',(null as any));
    this._el_72 = import3.createRenderElement(this.renderer,this._el_67,'dsp-button',new import3.InlineArray4(4,'size','md','variation','link'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'',(null as any));
    this._text_74 = this.renderer.createText(this._el_67,'\n                        ',(null as any));
    this._text_75 = this.renderer.createText(this._el_65,'\n                    ',(null as any));
    this._text_76 = this.renderer.createText(this._el_63,'\n                ',(null as any));
    this._text_77 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_78 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_79 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_80 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_81 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'submit',(null as any),'reset',(null as any)),this.eventHandler(this.handleEvent_4));
    this._pipe_translate_0 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_39,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_39));
    this._InputContainerComponent_39_3.subscribe(this,this.eventHandler(this.handleEvent_39),false,false,true);
    this._pipe_translate_3 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_48,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_48));
    this._InputContainerComponent_48_3.subscribe(this,this.eventHandler(this.handleEvent_48),false,false,true);
    this._pipe_translate_5 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_69,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_69));
    this._pipe_translate_7 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_72,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_72));
    this._pipe_translate_8 = new import28.TranslatePipe(this.parentView.injectorGet(import25.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._text_32,
      this._el_33,
      this._text_34,
      this._el_35,
      this._text_36,
      this._el_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._el_46,
      this._text_47,
      this._el_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._text_56,
      this._anchor_57,
      this._text_58,
      this._anchor_59,
      this._text_60,
      this._anchor_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._el_65,
      this._text_66,
      this._el_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._text_74,
      this._text_75,
      this._text_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._text_80,
      this._text_81
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import38.InputContainerComponent) && ((39 <= requestNodeIndex) && (requestNodeIndex <= 40)))) { return this._InputContainerComponent_39_3.context; }
    if (((token === import38.InputContainerComponent) && ((48 <= requestNodeIndex) && (requestNodeIndex <= 49)))) { return this._InputContainerComponent_48_3.context; }
    if (((token === import41.TemplateRef) && (57 === requestNodeIndex))) { return this._TemplateRef_57_5; }
    if (((token === import42.NgIf) && (57 === requestNodeIndex))) { return this._NgIf_57_6.context; }
    if (((token === import41.TemplateRef) && (59 === requestNodeIndex))) { return this._TemplateRef_59_5; }
    if (((token === import42.NgIf) && (59 === requestNodeIndex))) { return this._NgIf_59_6.context; }
    if (((token === import41.TemplateRef) && (61 === requestNodeIndex))) { return this._TemplateRef_61_5; }
    if (((token === import42.NgIf) && (61 === requestNodeIndex))) { return this._NgIf_61_6.context; }
    if (((token === import43.NgForm) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 78)))) { return this._NgForm_4_3.context; }
    if (((token === import44.ControlContainer) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 78)))) { return this._ControlContainer_4_4; }
    if (((token === import45.NgControlStatusGroup) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 78)))) { return this._NgControlStatusGroup_4_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import30.ValueUnwrapper();
    this._NgForm_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatusGroup_4_5.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_39_0_0:any = 'addpuName';
    this._InputContainerComponent_39_3.check_name(currVal_39_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_39_0_1:any = valUnwrapper.unwrap(this._pipe_translate_3.transform('pickupPoint.NAME'));
    this._InputContainerComponent_39_3.check_label(currVal_39_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_39_0_2:boolean = !!this.context.errors['addpuName'];
    this._InputContainerComponent_39_3.check_invalid(currVal_39_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_39_0_3:any = valUnwrapper.unwrap(this._pipe_translate_4.transform((((this.context.errors['addpuName'] == null)? (null as any): this.context.errors['addpuName'].pattern)? this.context.errorMessages['invalidAddpuName']: this.context.errorMessages['requiredAddpuName'])));
    this._InputContainerComponent_39_3.check_invalidText(currVal_39_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_39_0_4:any = this.context.dto.name;
    this._InputContainerComponent_39_3.check_model(currVal_39_0_4,throwOnChange,false);
    this._InputContainerComponent_39_3.ngDoCheck(this,this._el_39,throwOnChange);
    const currVal_48_0_0:any = 'addpuSurcharge';
    this._InputContainerComponent_48_3.check_name(currVal_48_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_48_0_1:any = valUnwrapper.unwrap(this._pipe_translate_5.transform('pickupPoint.COST'));
    this._InputContainerComponent_48_3.check_label(currVal_48_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_48_0_2:boolean = !!this.context.errors['addpuSurcharge'];
    this._InputContainerComponent_48_3.check_invalid(currVal_48_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_48_0_3:any = valUnwrapper.unwrap(this._pipe_translate_6.transform(this.context.errorMessages['addpuSurcharge']));
    this._InputContainerComponent_48_3.check_invalidText(currVal_48_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_48_0_4:any = this.context.dto.surcharge;
    this._InputContainerComponent_48_3.check_model(currVal_48_0_4,throwOnChange,false);
    this._InputContainerComponent_48_3.ngDoCheck(this,this._el_48,throwOnChange);
    const currVal_57_0_0:any = this.context.endLoading;
    this._NgIf_57_6.check_ngIf(currVal_57_0_0,throwOnChange,false);
    this._NgIf_57_6.ngDoCheck(this,this._anchor_57,throwOnChange);
    const currVal_59_0_0:any = (this.context.endLoading && (!this.context.isEditing || ((this.context.isEditing && !!this.context.dto.geoLocation.latitude) && !!this.context.dto.geoLocation.longitude)));
    this._NgIf_59_6.check_ngIf(currVal_59_0_0,throwOnChange,false);
    this._NgIf_59_6.ngDoCheck(this,this._anchor_59,throwOnChange);
    const currVal_61_0_0:any = (this.context.endLoading && (((this.context.dto == null)? (null as any): this.context.dto.destinationType) == 'AIRPORT'));
    this._NgIf_61_6.check_ngIf(currVal_61_0_0,throwOnChange,false);
    this._NgIf_61_6.ngDoCheck(this,this._anchor_61,throwOnChange);
    this._vc_57.detectChangesInNestedViews(throwOnChange);
    this._vc_59.detectChangesInNestedViews(throwOnChange);
    this._vc_61.detectChangesInNestedViews(throwOnChange);
    this._NgControlStatusGroup_4_5.checkHost(this,this,this._el_4,throwOnChange);
    const currVal_98:boolean = !this.context.endLoading;
    if (import3.checkBinding(throwOnChange,this._expr_98,currVal_98)) {
      this.renderer.setElementProperty(this._el_6,'hidden',currVal_98);
      this._expr_98 = currVal_98;
    }
    valUnwrapper.reset();
    const currVal_99:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_99,currVal_99))) {
      this.renderer.setText(this._text_13,currVal_99);
      this._expr_99 = currVal_99;
    }
    valUnwrapper.reset();
    const currVal_101:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('pickupPoint.POINT_OF_SALE_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_101,currVal_101))) {
      this.renderer.setText(this._text_16,currVal_101);
      this._expr_101 = currVal_101;
    }
    const currVal_103:boolean = !this.context.endLoading;
    if (import3.checkBinding(throwOnChange,this._expr_103,currVal_103)) {
      this.renderer.setElementProperty(this._el_20,'hidden',currVal_103);
      this._expr_103 = currVal_103;
    }
    valUnwrapper.reset();
    const currVal_104:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('pointOfSale.GENERAL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_104,currVal_104))) {
      this.renderer.setText(this._text_29,currVal_104);
      this._expr_104 = currVal_104;
    }
    const currVal_110:boolean = !this.context.isValid;
    if (import3.checkBinding(throwOnChange,this._expr_110,currVal_110)) {
      this.renderer.setElementProperty(this._el_69,'disabled',currVal_110);
      this._expr_110 = currVal_110;
    }
    valUnwrapper.reset();
    const currVal_111:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('common.SAVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_111,currVal_111))) {
      this.renderer.setText(this._text_70,currVal_111);
      this._expr_111 = currVal_111;
    }
    valUnwrapper.reset();
    const currVal_113:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('common.CANCEL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_113,currVal_113))) {
      this.renderer.setText(this._text_73,currVal_113);
      this._expr_113 = currVal_113;
    }
    this.compView_39.internalDetectChanges(throwOnChange);
    this.compView_48.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_39_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_48_3.context.ngAfterViewInit(); }
    }
  }
  destroyInternal():void {
    this._vc_57.destroyNestedViews();
    this._vc_59.destroyNestedViews();
    this._vc_61.destroyNestedViews();
    this.compView_39.destroy();
    this.compView_48.destroy();
    this._InputContainerComponent_39_3.ngOnDestroy();
    this._InputContainerComponent_48_3.ngOnDestroy();
    this._NgForm_4_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 57)) { return new View_AdditionalPointEditComponent1(this.viewUtils,this,57,this._anchor_57,this._vc_57); }
    if ((nodeIndex == 59)) { return new View_AdditionalPointEditComponent2(this.viewUtils,this,59,this._anchor_59,this._vc_59); }
    if ((nodeIndex == 61)) { return new View_AdditionalPointEditComponent3(this.viewUtils,this,61,this._anchor_61,this._vc_61); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._NgForm_4_3.handleEvent(eventName,$event) && result);
    return result;
  }
  handleEvent_39(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.name = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_48(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.surcharge = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_69(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.save()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_72(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.cancel()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/additionalPoint/edit/additional-point-edit.component.ngfactory.ts